import Accordion from '@/common/components/Accordion'
import InfoField from '@/common/components/InfoField'
import { EquipmentModelLatestFipeDataTires } from '@/features/equipmentModels/types/equipmentModelLatestFipe'

interface FipeTiresAccordionProps {
  tiresData?: EquipmentModelLatestFipeDataTires
}

export default function FipeTiresAccordion({ tiresData }: FipeTiresAccordionProps) {
  return (
    <Accordion
      name="Tires"
      head="Pneus"
      defaultOpen
      body={
        <div className="flex flex-col gap-1">
          <div className='flex items-center gap-1'>
            <InfoField 
              label="Dianteiros" 
              value={tiresData?.Dianteiros} 
            />
            <InfoField 
              label="Traseiros" 
              value={tiresData?.Traseiros} 
            />
            <InfoField 
              label="Altura Flanco" 
              value={tiresData?.["Altura Flanco"]} 
            />
          </div>
          <div className='flex items-center gap-1'>
            <InfoField 
              label="Altura" 
              value={tiresData?.Altura} 
            />
            <InfoField 
              label="Estepe" 
              value={tiresData?.Estepe} 
            />
          </div>
        </div>
      }
    />
  )
}